export const mockTransactionReportSalesGet = (body, params, options) => {
  const { guid = '' } = options || {};
  return {
    [guid]: {
      header: {
        label: 'date',
        lines: ['count'],
        biaxial: ['count'],
        currency: true,
        biaxialCurrency: false
      },
      data: [
        { date: 'Feb', count: 0, 'Merchant with Transaction Report Data': 0 },
        { date: 'Mar', count: 0, 'Merchant with Transaction Report Data': 0 },
        { date: 'Apr', count: 0, 'Merchant with Transaction Report Data': 0 },
        { date: 'May', count: 0, 'Merchant with Transaction Report Data': 0 },
        { date: 'Jun', count: 0, 'Merchant with Transaction Report Data': 0 },
        { date: 'Jul', count: 30, 'Merchant with Transaction Report Data': 51870 },
        { date: 'Aug', count: 0, 'Merchant with Transaction Report Data': 0 }
      ]
    }
  };
};

export default mockTransactionReportSalesGet;
